export function getUUID() {
    return ([1e7]+''+ -1e3 + -4e3 + -8e3 + -1e11).toString().replaceAll(/[018]/g, (c:any) =>
        (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
    );
}

export  const getDynamicHeight=(a:any,b:any) =>{
    if(a && a.length>3){
        return "180px"
    }
    if(b && b.length>3){
        return "180px"
    }
    return "";
}

export  const  getParameterValueFromUrl=(queryName:any):string=>{
    let reg = new RegExp("(^|&)" + queryName + "=([^&]*)(&|$)", "i");
    let result = window.location.search.substr(1).match(reg);
    if (result != null) {
        if(queryName === "url") {
            return decodeURIComponent(result[2]);
        }else {
            return unescape(result[2]);
        }
    } else {
        return "";
    }
}

export const getBlankOrSelf=(url:any,flag:string):string =>{

    if(url===undefined||url==null||url.startsWith('javascript')){
        return "_self"
    }

   return flag;

}